import { useApi } from "hooks"
import { useQuery } from "@tanstack/react-query"

const useGetAd = () => {

  const { apiFetch } = useApi()

  const url = '/advertisements';

  const getAd = () => {
    return apiFetch({ url })
      .then( res => res.data)
  }

  const options = {
    staleTime: 0,
    placeholderData: null,
    enabled: false,
  }

  return {
    ...useQuery(['ad'], getAd, options),
  }

}

export default useGetAd
